/**
 * Null-safe lowercase for user- or API-supplied strings.
 *
 * Several dashboard DTO fields are typed as `string` locally but can arrive
 * `null` from the API (e.g. an optional campaign Description). Calling
 * `.toLowerCase()` directly on such a value throws
 * "Cannot read properties of null (reading 'toLowerCase')" and — via the
 * app-level ErrorBoundary — blanks the whole page (ORB-448).
 *
 * Note an optional chain alone does NOT fix a search predicate:
 * `value?.toLowerCase().includes(query)` still throws on the `.includes(...)`
 * when `value` is null. Use this helper in any search / filter / compare path so
 * a missing value simply behaves like an empty string.
 */
export function lowerSafe(value: string | null | undefined): string {
  return (value ?? '').toLowerCase()
}
